import { render, staticRenderFns } from "./ListagemTurmas.vue?vue&type=template&id=4fa469fc&scoped=true"
import script from "./ListagemTurmas.vue?vue&type=script&lang=js"
export * from "./ListagemTurmas.vue?vue&type=script&lang=js"
import style0 from "./ListagemTurmas.vue?vue&type=style&index=0&id=4fa469fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa469fc",
  null
  
)

export default component.exports